import { MEDIA_URL } from '@/constants/env';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import Image from '@/ui/Image';

export default function SinglePostLayout({ post }) {
  return (
    <FullWidthLayout>
      <section className="my-8 px-4 md:my-16">
        <div className="mx-auto max-w-prose">
          {post.date && (
            <span className="block text-center font-semibold italic text-primary-400">
              {new Date(post.date).toDateString()}
            </span>
          )}
          {post.subtitle && (
            <span className="block text-center font-semibold italic text-primary-400">
              {post.subtitle}
            </span>
          )}
          {post.title && (
            <h2 className="mt-2 text-center text-2xl font-semibold md:text-3xl lg:text-4xl lg:font-bold">
              {post.title}
            </h2>
          )}
          {post.image && (
            <Image
              className="mt-8 aspect-video overflow-hidden rounded-lg object-cover"
              src={MEDIA_URL.concat(post.image)}
            />
          )}
          <article
            className="prose prose-neutral mt-8"
            dangerouslySetInnerHTML={{ __html: post.content }}
          ></article>
        </div>
      </section>
    </FullWidthLayout>
  );
}
